export default {
  getUserAgent() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return "WeChatPay";
    } else if (ua.match(/AlipayClient/i) == "alipayclient") {
      return "AliPay";
    } else {
      return "H5";
    }
  },
  auth(redirectUrl) {
    // console.log('授权方法')
    // if (this.getUserAgent() == "WeChatPay") {
    // console.log('微信授权')
    let appId = "wx3d58e6bcd1544bf4";
    let url = encodeURIComponent(redirectUrl);
    let targetUrl =
      "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
      appId +
      "&redirect_uri=" +
      url +
      "&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
    window.location.href = targetUrl;
    // }
  },
  getUrlKey(name) {
    return (
      decodeURI(
        (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
          location.href
        ) || [, ""])[1].replace(/\+/g, "%20")
      ) || null
    );
  },
  cardName() {
    const mallNameList = ["gongyinas"];
    const mallName = window.location.host.split(".")[0]
    if (mallNameList.indexOf(mallName) > -1) {
      return {
        name: "购物车",
        type: true
      };
    }
    return {
      name: "兑换袋",
      type: false
    };
  },
  getMallUrl(string) {
    const url = window.location.href
    if(url.search(string) != -1) {
      return true
    } 
    return false
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/common.js